<script lang="ts">

    import { getContext } from 'svelte';
    import { navigate } from "svelte-routing";
    import DownloadPopup from './DownloadPopup.svelte';
    const { open } = getContext('simple-modal');

    open(DownloadPopup, {}, {}, {
        onClose: () => {
            navigate("/", { replace: false });
        }
    });

</script>

<div>

</div>

<style lang="scss">

</style>